import axios from '@/lib/axios';
import { PaymentTaskComment, PurchaseOrderContractTaskComment } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1160. 支払タスク固定資産登録
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/payment_task_fixed_assets
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  fixed_asset_id: number;
  amount: number;
};
const createPaymentTaskFixedAsset = (props: Props): Promise<PaymentTaskComment> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/payment_task_fixed_assets`,
    props
  );
};

export const useCreatePaymentTaskFixedAsset = () => {
  return useMutation({
    mutationFn: createPaymentTaskFixedAsset,
  });
};
